module.exports = __webpack_public_path__ + "img/promo_diskon.5faa0579.svg";